
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1609846162147",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2348",
    "data-darkreader-inline-fill": "",
    "width": "64",
    "height": "64"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M930.816 676.224a352 352 0 0 0-75.712-112.32 352 352 0 0 0-96.448-68.544 234.88 234.88 0 0 0 82.048-178.624 235.776 235.776 0 0 0-236.8-235.392 235.392 235.392 0 0 0-206.784 125.312 235.392 235.392 0 0 0-217.6 234.752 234.944 234.944 0 0 0 82.048 178.56 352 352 0 0 0-96.448 68.544 352 352 0 0 0-75.712 112.32 350.72 350.72 0 0 0-25.984 101.056 33.024 33.024 0 0 0 32.768 36.48h33.216a33.024 33.024 0 0 0 32.704-29.44 252.672 252.672 0 0 1 72.832-150.464 255.168 255.168 0 0 1 25.6-22.528 251.776 251.776 0 0 1 124.8-50.304 257.856 257.856 0 0 1 29.376-1.664 252.736 252.736 0 0 1 179.904 74.496 252.544 252.544 0 0 1 72.832 150.464 33.024 33.024 0 0 0 32.704 29.44h33.216a33.024 33.024 0 0 0 32.768-36.48 350.08 350.08 0 0 0-25.92-101.12 352.32 352.32 0 0 0-75.712-112.32 352.576 352.576 0 0 0-96.448-68.544 235.968 235.968 0 0 0 50.24-60.352 252.736 252.736 0 0 1 166.848 74.176 252.544 252.544 0 0 1 72.832 150.464 33.024 33.024 0 0 0 32.768 29.44h33.216a33.024 33.024 0 0 0 32.768-36.48 349.632 349.632 0 0 0-25.92-100.928zM551.232 442.24a135.552 135.552 0 0 1-40 96 135.616 135.616 0 0 1-96.512 40 135.68 135.68 0 0 1-59.648-13.632 136.512 136.512 0 0 1-36.864-26.304 135.616 135.616 0 0 1-40-96.512 135.68 135.68 0 0 1 40-96.576 135.936 135.936 0 0 1 51.712-32.512 136.832 136.832 0 0 1 44.8-7.488 135.744 135.744 0 0 1 54.016 11.072 135.808 135.808 0 0 1 42.496 28.928 135.616 135.616 0 0 1 40 96.576z m150.592-28.928a135.872 135.872 0 0 1-51.712 32.512v-4.416a235.456 235.456 0 0 0-144.96-217.6l3.584-3.776a135.68 135.68 0 0 1 96.576-40 135.616 135.616 0 0 1 96.576 40 135.68 135.68 0 0 1 40 96.512 135.68 135.68 0 0 1-40.064 96.832z",
        "p-id": "2349",
        "data-darkreader-inline-fill": "",
        "style": "--darkreader-inline-fill:#282b2b;"
      }
    }
  ]
})
    }
  